import { AxiosInstance } from 'axios';
import { StatementPoints } from './types';

const postStatementAllowedData = (api: AxiosInstance) => ({
  postStatementAllowed: async (payload: any, type: string) => {
    const { data } = await api.post(
      `${StatementPoints.POST_ALLOWED}/${type}`,
      payload,
    );
    return data;
  },
});

const postStatementCreateData = (api: AxiosInstance) => ({
  postStatementCreate: async (payload: any, type: string) => {
    const { data } = await api.post(
      `${StatementPoints.POST_CREATE}/${type}`,
      payload,
    );
    return data;
  },
});

const statementService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...postStatementAllowedData(api),
    ...postStatementCreateData(api),
  };
};

export default statementService;



// WEBPACK FOOTER //
// ./src/services/statement/statementService.ts